enum OrderOptimizerTaxiListingFilterType {
  ORDER_HUMAN_ID = "ORDER_HUMAN_ID",
  MAXIMUM_DELAY = "MAXIMUM_DELAY",
  MAXIMUM_HALTING_TIME = "MAXIMUM_HALTING_TIME",
  IGNORE_DRIVER_ROUTES = "IGNORE_DRIVER_ROUTES",
  STATUS = "STATUS",
}

export default OrderOptimizerTaxiListingFilterType;
